import React, { useEffect } from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederUtlandDto from '../Models/VeilederUtlandDto';
import { VeilederUtlandAppState } from '../Store';
import { connect } from 'react-redux';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { StamdataUtlandHelgradModel } from '../Models/StamdataUtlandHelgradModel';
import * as ValgTypes from '../Store/Valg/Types';
import * as UtregningUtland from '../Utilities/Utregning';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface UtbetalingOwnProps {
    satser: StamdataUtlandHelgradModel | null,
    valg: ValgTypes.ValgState,
    tittel: JSX.Element | null,
    locale: string,
    valuta: string,
}

type UtbetalingProps = UtbetalingOwnProps & MapStateToProps & {};

const UtbetalingDetaljerComponent = (props: UtbetalingProps): JSX.Element => {
    const { epiContext } = props;
    useEffect(() => {
        updateLiveMessage();
    }, []);
    let utvidetStipend: JSX.Element | null = null;
    let skolepengeStipend: JSX.Element | null = null;

    let skolepengeUtvidetStipend: number = UtregningUtland.regnUtSkolepengeUtvidetStipend(props.valg, props.satser);
    if (skolepengeUtvidetStipend > 0) {
        utvidetStipend = <div role="row" className="c-table__data-row">
                            <div role="cell" className="c-table__data-cell">
                                {contentResolver(epiContext, 'detaljerSkolepengeTilleggsstipend')}
                            </div>
                            <div role="cell" className="c-table__data-cell">
                                {UtregningUtland.formatNumber(skolepengeUtvidetStipend, props.locale)}
                                &nbsp;{props.valuta}
                            </div>
                          </div>;

        let skolepengeLanUtenUtvidetStipend = UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).stipendKroner - skolepengeUtvidetStipend;
        skolepengeStipend = <div role="cell" className="c-table__data-cell">
                                {UtregningUtland.formatNumber(skolepengeLanUtenUtvidetStipend, props.locale)}
                                &nbsp;{props.valuta}
                            </div>
    } else {
        skolepengeStipend = <div role="cell" className="c-table__data-cell">
                                {UtregningUtland.formatNumber(UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).stipendKroner, props.locale)}
                                &nbsp;{props.valuta}
                            </div>
    }

    

    return (
        <div>
            <h4>{props.tittel}</h4>
            <div role="table" className="c-table">
                <div role="row" className="c-table__header-row">
                    <div role="columnheader" className="c-table__header-cell c-table__header-cell--lilac">
                        {contentResolver(epiContext, 'tittelYtelseKolonne')}
                    </div>
                    <div role="columnheader" className="c-table__header-cell c-table__header-cell--lilac">
                        {contentResolver(epiContext, 'tittelBelopKolonne')}
                    </div>
                </div>
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerBasisLan')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {UtregningUtland.formatNumber(UtregningUtland.regnUtBasisLan(props.valg, props.satser).totaltStipendOgLan, props.locale)}
                        &nbsp;{props.valuta}
                    </div>
                </div>
                {UtregningUtland.regnUtRekrutteringsstipend(props.valg, props.satser) > 0 && (
                    <div role="row" className="c-table__data-row">
                        <div role="cell" className="c-table__data-cell">
                            {contentResolver(epiContext, 'detaljerRekrutteringsstipend')}
                        </div>
                        <div role="cell" className="c-table__data-cell">
                            {UtregningUtland.formatNumber(
                                UtregningUtland.regnUtRekrutteringsstipend(props.valg, props.satser), props.locale,
                            )}
                            &nbsp;{props.valuta}
                        </div>
                    </div>
                )}
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerSkolepengeLan')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {UtregningUtland.formatNumber(UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).lanKroner, props.locale)}
                        &nbsp;{props.valuta}
                    </div>
                </div>
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerSkolepengeStipend')}
                    </div>
                    {skolepengeStipend}
                </div>
                
                {utvidetStipend}

                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerReiselan')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {UtregningUtland.formatNumber(UtregningUtland.regnUtReiseStotte(props.valg, props.satser).lanKroner, props.locale)}
                        &nbsp;{props.valuta}
                    </div>
                </div>
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerReiseStipend')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                    {UtregningUtland.formatNumber(UtregningUtland.regnUtReiseStotte(props.valg, props.satser).stipendKroner, props.locale)}
                        &nbsp;{props.valuta}
                    </div>
                </div>
            </div>
        </div>
    );
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederUtlandDto>;
}

export default connect(
    (state: VeilederUtlandAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
)(UtbetalingDetaljerComponent);